import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { getUserRole } from "../utils/index";
import {
  faSearch,
  faTrashAlt,
  faPen,
  faTimes,
  faUndo,
  faChartBar,
  faEye,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../layout/datatableConstants";
import { Link } from "react-router-dom";


const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const LeaseListingTable = ({ ths }) => {
  //console.log(asset);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [leaseId, setLeaseId] = useState(0);
  const [popupKey, setpopupKey] = useState(0);
  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/outflow/get-outflow-details?page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const deleteOutflow = (id) => {
    var del_message = "Are you sure you want to delete this outflow.";


    confirmAlert({
      title: "Confirm to delete",
      message: del_message,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/outflow/delete?id=` + id,
              data: { id: id },
            }).then(function (response) {
              ths.resetCounter();
              //ths.loadLeaseCountStatuswise();
            });
          },
        },
        {
          label: "No",
          onClick: () => {
            console.log("cancel clicked");
          },
        },
      ],
    });
  };

  function DeleteBtn(props) {
    return (

      <>
        <span
          className="tableActionDelete"
          onClick={() => deleteOutflow(props.outflowId, props.ths)}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </span>
      </>

    );
  }

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/outflow/get-outflow-details?page=${page}&per_page=${newPerPage}&delay=1`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalGraphOpen, setGraphOpen] = React.useState(false);

  function openFromParent() {
    setIsOpen(true);
  }

  function modalGraphClose() {
    setGraphOpen(false);
  }

  function handleCloseModal() {
    setIsOpen(false);
  }

  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Outflow Type",
      selector: "outflow_type",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Asset Name",
      selector: "asset_name",
      sortable: false,
      grow: 3,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "From Period",
      selector: "from_period",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "To Period",
      selector: "to_period",
      sortable: false,
      grow: 1,
      wrap: true,
    },
    {
      name: "Expense",
      selector: "total_expense",
      sortable: false,
      grow: 1,
      wrap: true,
    },
    {
      name: "Action",
      grow: 3,
      sortable: false,
      cell: (record) => {
        return (
          <div>
            <span className="tableActionEdit">
              <Link to={`/outflow/update/${record.outflow_id}`}>
                {" "}
                <FontAwesomeIcon icon={faPen} />
              </Link>
            </span>

            <DeleteBtn
              outflowId={record.outflow_id}
              ths={ths}
            ></DeleteBtn>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="padding_left_class">
        <div className="tableContainer">
          <DataTable
            
            columns={columns}
            data={data}
            customStyles={datatableOptions.datatableOptions.customStyle}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            onChangePage={handlePageChange}
            paginationComponentOptions={
              datatableOptions.datatableOptions.paginationOptions
            }
          />
          {/* <Popup open={true} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup> */}
        </div>
      </div>


    </>
  );
};
export default LeaseListingTable;
